module.exports = __webpack_public_path__ + "img/3.2c42e0b0.png";